var chunkToChildrenMap = {
	"704": [
		245
	],
	"765": [
		245,
		985
	],
	"776": [
		245
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };